<style src="./StageChecker.scss" lang="scss"></style>

<template>
  <div class="stage-checker">
    <div class="title-container">
      <h3 class="title">Resposabilidades</h3>
    </div>
    <div
      class="item-container"
      v-for="(item, key) in listData"
      :key="key">

      <button
        type="button"
        class="item"
        :class="{ 'checked-item': checkedList.includes(item.value) }"
        @click="selectItem(item.value)">
        {{ item.text }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EditUser',
    props: {
      listData: {
        default: []
      },
      value: {
        default: []
      }
    },
    data () {
      return {
        checkedList: []
      }
    },
    watch: {
      value (value) {
        this.updateChecker(value)
      }
    },
    methods: {
      updateChecker (value) {
        this.checkedList = value
      },
      selectItem (selectedItem) {
        const list = [...this.checkedList]
        const index = list.indexOf(selectedItem)
        if (index > -1) {
          list.splice(index, 1)
        } else {
          list.push(selectedItem)
        }

        this.checkedList = list

        this.$emit('input', list)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/record/user/components/stage-checker/StageChecker.vue